module.exports = __webpack_public_path__ + "static/us_map-4e43cfae5759f79ba42b9b5b1b39771a.png";